export class UserAuth {
    constructor (
        public username: string,
        public password: string) {

    }
}